/**
 * Simple Size Guide JavaScript with Tab Switching
 * Handles switching between Upper Body and Lower Body tabs
 */

class SimpleSizeGuide extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.tabs = this.querySelectorAll('.size-guide-tab');
    this.contents = this.querySelectorAll('.size-guide-content');

    // Initialize tab functionality
    this.initTabs();
  }

  initTabs() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const targetTab = tab.dataset.tab;

        // Update tab states
        this.tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        // Update content visibility
        this.contents.forEach(content => {
          if (content.dataset.content === targetTab) {
            content.classList.remove('hidden');
            content.classList.add('active');
          } else {
            content.classList.add('hidden');
            content.classList.remove('active');
          }
        });
      });
    });
  }
}

// Register the custom element
if (!customElements.get('simple-size-guide')) {
  customElements.define('simple-size-guide', SimpleSizeGuide);
}

// Initialize existing elements on page load and after dynamic content loads
function initSizeGuides() {
  const sizeGuides = document.querySelectorAll('.simple-size-guide');
  sizeGuides.forEach(guide => {
    if (!guide.classList.contains('initialized')) {
      guide.classList.add('initialized');
      // The custom element will auto-initialize
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSizeGuides);
} else {
  initSizeGuides();
}

// Re-initialize when popup content is loaded (for product-addons modal)
document.addEventListener('click', (e) => {
  if (e.target.closest('.product-addons__size-guide')) {
    setTimeout(() => {
      initSizeGuides();
      // Ensure tables are properly formatted
      const sizeGuides = document.querySelectorAll('.simple-size-guide');
      sizeGuides.forEach(guide => {
        const tables = guide.querySelectorAll('table');
        tables.forEach(table => {
          if (!table.classList.contains('size-chart-table')) {
            table.classList.add('size-chart-table');
          }
        });
      });
    }, 100);
  }
});
